import { render, staticRenderFns } from "./saleOrder.vue?vue&type=template&id=5c465b42"
import script from "./saleOrder.vue?vue&type=script&lang=js"
export * from "./saleOrder.vue?vue&type=script&lang=js"
import style0 from "./saleOrder.vue?vue&type=style&index=0&id=5c465b42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports